import { IParceiroContato } from "./parceiro.model";

export enum SITUACAO_RFB {
  CANCELADA = 'CANCELADA',
  NULA = 'NULA',
  PENDENTE_DE_REGULARIZACAO = 'PENDENTE DE REGULARIZACAO',
  REGULAR = 'REGULAR',
  SUSPENSA = 'SUSPENSA',
  CANCELADA_POR_MULTIPLICIDADE = 'CANCELADA POR MULTIPLICIDADE',
  CANCELADA_POR_ENCERRAMENTO_DE_ESPOLIO = 'CANCELADA POR ENCERRAMENTO DE ESPOLIO',
  CANCELADA_POR_OBITO_SEM_ESPOLIO = 'CANCELADA POR OBITO SEM ESPOLIO',
  CANCELADA_DE_OFICIO = 'CANCELADA DE OFICIO',
  TITULAR_FALECIDO = 'TITULAR FALECIDO'
}

export interface IConsultaPredictusPessoaEndereco {
  tipoLogradouro?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  uf?: string;
  cep?: string;
}

export interface IConsultaPredictusPessoaContato {
  tipo?: string;
  numero?: string;
}

export interface IConsultaPredictusPessoaParticipacoes {
  cnpj?: string;
  razaoSocial?: string;
  cargo?: string;
  participacao?: string;
  dataEntrada?: string;
}

export interface IConsultaPredictusPessoaRFB {
  anoObito?: string;
  dataConsulta?: string;
  situacao: SITUACAO_RFB;
}

export interface IConsultaPredictusPessoaRenda {
  faixaRenda?: string;
  origemRenda?: string;
}

export interface IConsultaPredictusPessoaFisica {
  cpf?: string;
  nome?: string;
  rg?: string;
  orgaoEmissor?: string;
  ufEmissao?: string;
  dataEmissao?: string;
  nomeMae?: string;
  nomePai?: string;
  sexo?: string;
  dataNascimento?: string;
  escolaridade?: string;
  emails: string[];
  participacoes: IConsultaPredictusPessoaParticipacoes[];
  rendaPresumida: IConsultaPredictusPessoaRenda;
  enderecos: IConsultaPredictusPessoaEndereco[];
  telefones: IConsultaPredictusPessoaContato[];
  situacaoRfb: IConsultaPredictusPessoaRFB;
  contatos?: IParceiroContato[];
}

export const MOCK_PESSOA_FISICA: IConsultaPredictusPessoaFisica = {
  cpf: '99999999999',
  nome: 'NOME DA PESSOA',
  rg: '65545455',
  ufEmissao: 'SP',
  nomeMae: 'NOME DA MAE',
  sexo: 'M',
  dataNascimento: '1999-11-01',
  emails: ['email1@gmail.com'],
  contatos: [],
  participacoes: [
    {
      cnpj: '999999999000199',
      razaoSocial: 'EMPRESA LTDA',
      cargo: 'Diretor',
      participacao: '0.00',
      dataEntrada: '2013-01-01'
    }
  ],
  rendaPresumida: {
    faixaRenda: 'B (entre 10 e 20 SM)',
    origemRenda: 'EMPRESARIO'
  },
  enderecos: [
    {
      tipoLogradouro: 'R',
      logradouro: 'XPTO',
      numero: '198',
      complemento: 'AP 102',
      bairro: 'BAIRRO',
      cidade: 'SAO PAULO',
      uf: 'SP',
      cep: '12548123'
    }
  ],
  telefones: [
    {
      tipo: 'MOVEL',
      numero: '11999999999'
    },
    {
      tipo: 'FIXO',
      numero: '1133333333'
    }
  ],
  situacaoRfb: {
    anoObito: '2012',
    dataConsulta: '2020-02-25T00:00:00',
    situacao: SITUACAO_RFB.REGULAR
  }
};
